export type ApiErrorKind =
  'network' | 'timeout' | 'authentication' | 'http' | 'cancelled' | 'response';

export abstract class ApiError extends Error {
  abstract readonly kind: ApiErrorKind;

  constructor(message?: string, cause?: unknown) {
    super(message, { cause });
  }
}

export class NetworkError extends ApiError {
  override readonly name = 'NetworkError';
  readonly kind = 'network';
}

export class TimeoutError extends ApiError {
  override readonly name = 'TimeoutError';
  readonly kind = 'timeout';
}

export class AuthenticationError extends ApiError {
  override readonly name = 'AuthenticationError';
  readonly kind = 'authentication';
}

export class RequestCancelledError extends ApiError {
  override readonly name = 'RequestCancelledError';
  readonly kind = 'cancelled';
}

export class ResponseParseError extends ApiError {
  override readonly name = 'ResponseParseError';
  readonly kind = 'response';
}

export class HttpError extends ApiError {
  override readonly name = 'HttpError';
  readonly kind = 'http';

  constructor(
    readonly status: number,
    statusText?: string,
  ) {
    super(statusText && statusText.length > 0 ? statusText : `HTTP ${status}`);
  }
}
